module.exports = __webpack_public_path__ + "img/onboarding-decoration-1.6baf355b.svg";